import {Editor, Path, Transforms} from 'slate';
import makeChoice from '../factory/makeChoice';
import makeListItem from '../factory/makeListItem';
import makeOrderedListItem from '../factory/makeOrderedListItem';
import makeProcessStep from '../factory/makeProcessStep';

const LIST_ITEM_TYPES = ['list-item', 'ordered-list-item'];

function insertDataIntoSingleLineElementGroup (editor, data, selectionMeta) {
  const {
    selectionStartElement,
    isSelectionInSingleElement,
  } = selectionMeta;

  if (
    !selectionStartElement ||
    (
      selectionStartElement.type !== 'choice' &&
      selectionStartElement.type !== 'process-step-title' &&
      !LIST_ITEM_TYPES.includes(selectionStartElement.type)
    ) ||
    !isSelectionInSingleElement
  ) {
    return false;
  }

  const text = data.getData('text');
  const [firstLine, ...otherLines] = getTrimmedNonEmptyLines(text);

  // Insert the first line
  editor.insertText(firstLine);

  if (!otherLines.length) {
    return true;
  }

  // Add the other lines
  const selectedElementPath = editor.selection.anchor.path.slice(0, -1);
  const parentPath = Path.parent(selectedElementPath);
  let linePath = selectionStartElement.type === 'process-step-title' ? parentPath : selectedElementPath;
  otherLines.forEach((line) => {
    linePath = Path.next(linePath);

    let newNode;
    if (selectionStartElement.type === 'process-step-title') {
      newNode = makeProcessStep({title: line});
    }
    else if (selectionStartElement.type === 'list-item') {
      newNode = makeListItem({text: line, indent: selectionStartElement.indent});
    }
    else if (selectionStartElement.type === 'ordered-list-item') {
      newNode = makeOrderedListItem({text: line, indent: selectionStartElement.indent});
    }
    else {
      newNode = makeChoice({text: line});
    }

    Transforms.insertNodes(editor, newNode, {at: linePath});
  });

  // Handle any text to the right of the user's selection before they pasted,
  // and move the cursor to the end of the pasted content.
  const selectedLeafPath = editor.selection.anchor.path;
  const selectedLeafOffset = editor.selection.anchor.offset;
  const firstLineElementText = Editor.string(editor, selectedLeafPath);
  const textToRightOfFirstLine = firstLineElementText.slice(selectedLeafOffset);

  if (textToRightOfFirstLine.length) {
    Editor.deleteForward(editor, {unit: 'line'});
  }

  const endPos = Editor.end(editor, [...linePath, 0]);
  requestAnimationFrame(() => {
    Transforms.select(editor, endPos);
    editor.insertText(textToRightOfFirstLine);
    Transforms.select(editor, endPos);
  });
  return true;
}

function getTrimmedNonEmptyLines (text) {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '');
}

export default insertDataIntoSingleLineElementGroup;
